import { StateCreator } from 'zustand';

/** The grid's header filters; an empty list filters nothing. */
export interface OASISManagerColumnFilters {
  visitTypes: string[];
  clinicians: string[];
  clinics: string[];
  shpStatuses: string[];
}

export const EMPTY_OASIS_MANAGER_COLUMN_FILTERS: OASISManagerColumnFilters = {
  visitTypes: [],
  clinicians: [],
  clinics: [],
  shpStatuses: [],
};

export interface OASISManagerFilters {
  activeTab: 'incomplete' | 'ready_to_export' | 'exported';
  patientSearch: string;
  clinicId: string | null;
  hideTest: boolean;
  hideImportedPatients: boolean;
  /** EMR-3171: exclude visits dated before the patient's confirmed take-over day (Visit.visit_date). */
  excludePreTakeover: boolean;
  columnFilters: OASISManagerColumnFilters;
}

export interface OASISManagerSlice {
  oasisManagerFilters: OASISManagerFilters;
  setOASISManagerFilters: (filters: Partial<OASISManagerFilters>) => void;
}

const DEFAULT_OASIS_MANAGER_FILTERS: OASISManagerFilters = {
  activeTab: 'incomplete',
  patientSearch: '',
  clinicId: null,
  hideTest: true,
  hideImportedPatients: true,
  excludePreTakeover: true,
  columnFilters: EMPTY_OASIS_MANAGER_COLUMN_FILTERS,
};

export const oasisManagerSlice: StateCreator<OASISManagerSlice> = set => ({
  oasisManagerFilters: DEFAULT_OASIS_MANAGER_FILTERS,
  setOASISManagerFilters: (filters: Partial<OASISManagerFilters>) =>
    set(state => ({
      oasisManagerFilters: { ...state.oasisManagerFilters, ...filters },
    })),
});
